import React from 'react';
import '../assets/styles/modal.css';

const DepositModal = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <button className="modal-close" onClick={onClose}>&times;</button>

                <h2 style={{ marginBottom: '20px', textAlign: 'center' }}>Depositar Fondos</h2>

                <div style={{ background: 'rgba(255,255,255,0.05)', padding: '20px', borderRadius: '10px', marginBottom: '20px' }}>
                    <h4 style={{ color: '#4caf50', marginTop: 0, marginBottom: '15px' }}>Transferencia Bancaria</h4>

                    <div style={{ display: 'grid', gap: '10px', fontSize: '0.95rem' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <span style={{ opacity: 0.7 }}>Empresa:</span>
                            <strong>Xcorp Gestion Spa</strong>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <span style={{ opacity: 0.7 }}>RUT:</span>
                            <strong>76.671.532-K</strong>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <span style={{ opacity: 0.7 }}>Banco:</span>
                            <strong>Banco Santander</strong>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <span style={{ opacity: 0.7 }}>Tipo de Cuenta:</span>
                            <strong>Cuenta Corriente</strong>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <span style={{ opacity: 0.7 }}>Número:</span>
                            <strong>0-000-8876343-2</strong>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <span style={{ opacity: 0.7 }}>Correo:</span>
                            <strong>depositos@xcoin.cl</strong>
                        </div>
                    </div>
                </div>

                <div style={{ background: 'rgba(255,255,255,0.05)', padding: '20px', borderRadius: '10px' }}>
                    <h4 style={{ color: '#ff9800', marginTop: 0, marginBottom: '10px' }}>Otras Opciones</h4>
                    <p style={{ fontSize: '0.9rem', lineHeight: '1.5', margin: 0 }}>
                        También puedes depositar presencialmente usando <strong>Tarjeta de Crédito, Débito o Efectivo</strong>.
                        <br /><br />
                        Acércate a nuestras oficinas o coordina con un ejecutivo vía WhatsApp para asistencia personalizada.
                    </p>
                </div>

                <div className="modal-actions" style={{ marginTop: '20px', justifyContent: 'center' }}>
                    <button className="btn btn-primary" onClick={onClose}>
                        Entendido
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DepositModal;
